export enum MapCageZone {
  SourceId = 'cageZones',
  Layer = 'cage-zone-layer',
  Border = 'cage-zone-border',
  Text = 'cage-zone-text',
}
